<script>
    import BlogSummary from '../components/BlogSummary.svelte';
    export let short = false;
    export let blogUrl = "kyykkya-joka-paiva";
    let title = "Kyykkyä joka päivä - 26 päivää";
    let author = "Markus";
    let blogDate = "18.8.2018";
    let titlePic = "kyykky-800x787.jpg";
    let firstPara = "Olen aina pitänyt etukyykkyä itselleni epämukavana liikkeenä. Huono tekniikka heijastui myös moniin muihin liikkeisiin. Niinpä olikin aika osoittaa itsekuria ja ottaa etukyykky liikkeenä haltuun.";
</script>
<!--  Blogi koostuu kahdesta osasta. Eka osa "short" on siis muille siuville tuleva lyhennelmä, jossa on artikkelikuva ja lyhyt teksti -->

{#if short}
<BlogSummary blogPath={blogUrl} title={title} titlePic={titlePic} blogDate={blogDate} firstPara={firstPara}></BlogSummary>

{:else}
    <div class="blog page">
        <article class="container">
            <h1>{title}</h1>
            <div class="blogDate">{author} | {blogDate}</div>
            <div class="blogMainImage" style="background-image: url('/svelte-site/img/blog/{titlePic}')"></div>
            
            
            <p>Levytangolla tehtävistä kyykkyliikkeistä etu- ja takakyykky ovat ne tunnetuimmat ja tehokkaimmat versiot. 
                Olen viimeisinä vuosina yrittänyt tehdä selkäni vuoksi enemmän etukyykkyä kuin takakyykkyä, sillä etukyykky on selälle
                kevyempi vaihtoehto. Samalla myös painot ovat maltillisemmat. 
                Etukyykky on myös keskivartalon vahvistamiseen erinomainen liike.</p>

            <p>
                Olen aina pitänyt etukyykkyä itselleni epämukavana liikkeenä. Ylipäätään emme tykkää tehdä asioita missä
                olemme huonoja. Tuskaillessani etukyykyn vaikeuden kanssa, myös thrusterit ja rinnallevedot ovat olleet
                yltä lailla hankalia. Myös vauhtipunnerrukseen on ollut vaikea saada jaloista voimaa. Niinpä olikin jo
                aika osoittaa itsekuria ja hioa etukyykyn tekniikkaa. </p>

            <h3>Kyykkyä joka päivä 26 päivää putkeen</h3>

            <p>Päätin siis ottaa haasteen vastaan ja kyykätä “kesälomani” aikana joka päivä. Minulla ei ollut käytössä
                mitään ennalta määriteltyä kyykkyohjelmaa. Osa päivistä meni tehdessä raskaita lyhyitä sarjoja ja osa
                pitempiä ja kevyempiä sarjoja. Tein vain sitä, mikä tuntui hauskalta. Tärkeintä oli tehdä kyykyt joka
                päivä ja saada alle mahdollisimman monipuolisesti treeniä.
            </p>
            <p>
                Etukäteen ajattelin, että suurin haaste tällaisessa joka päivä toistuvassa treenaamisessa olisi
                palautuminen. Ja kun olen muiden kanssa keskustellut omasta kyykkyhaasteestani, niin aina ensimmäisenä
                on sivuttu palautumista.
            </p>
            <p>
                "Eikö siinä mene aivan jumiin?"<br>
                "Miten ehdit palautua seuraavaksi päiväksi?"<br>
                "Miltä se on tuntunut?"<br>
            </p>
            <p>
                Lopulta palautuminen oli helposti hallittavissa. Teen kevyemmän treenin niinä päivinä, kun jalat
                tuntuvat, etteivät kestä raskaita nostoja. Toki sitten viimeisinä päivinä reidet, alaselkä ja pakarat
                olivat aivan juntturassa. Jumit eivät ihme kyllä vaikuttaneet kyykkyliikkeeseen mitenkään
                negatiivisesti, kaikkeen muuhun kylläkin. Ehkä näin jälkikäteen ajateltuna olisi voinut ottaa muutaman
                päivän vieläkin kevyemmin. Kroppa ehtii aivan mainiosti palautua, jos vaan kuormitus on oikea.
            </p>
            <p>Sen sijaan se todellinen haaste on sitoutumisessa.</p>

            <p>Kaikki tavoittelemisen arvoiset asiat vaativat sitoutumista. Ja kesällä, kun kalenteri on täysin
                epäsäännöllinen, niin säännöllisessä treenirytmissä pysyminen on vaivalloista. 26 treenipäivää putkeen
                vaatii jo hieman hulluutta. Onneksi olen pystynyt järjestämään treenimahdollisuuteni niin hyviksi, että
                tällaisetkin hullutukset onnistuvat.</p>

            <h3>Mikä muuttui?</h3>

            <p><strong>Mitä konkreettisesti tapahtuu, kun kyykätään joka päivä useampana päivänä?</strong></p>

            <p>Kaiken kaikkiaan tein takakyykkyä, etukyykkyä ja valakyykkyä. Askelkyykkyjä, rinnallevetoja ja
                thrustereita en laskenut kyykkyhaasteeseen matkaan, vaikka niissä kyykkyä jotakuinkin tehdäänkin.
                Säännöllisesti kyykätessä tuntuma on koko ajan hyvä. Tuntuu, ettei tarvitse samaa lämmittelyä (vai
                johtuuko se näistä helteistä) kuin harvemmin treenatessa. Kroppa on jotenkin valmiimpi koko ajan.</p>

            <p>Samaan aikaan etukyykyssä asennon pitäminen on helpottunut. Liike tuntuu helpommalta ja
                luonnollisemmalta. Raskaat painot ovat helpommin hallittavissa ja voiman tuotto tulee paremmin jaloista,
                eikä kaikki keskittyminen mene keskivartalon jännittämiseen. Sen huomaa erityisesti thrustereissa, jotka
                ovat minulle olleet aina erityisen vaikeita. Jotenkin sellaisesta semi raskaasta thrusterista tulikin
                yhtäkkiä kevyt.</p>

            <p>Tein etukyykyssä säännöllisesti kolmosia 90% kuormalla yhden toiston maksimista. Niistä palautuminen ei
                ollut missään vaiheessa ongelma. Asento pysyi hyvin ja nostot olivat melkein helppoja.</p>

            <p>Toinen iso asia oli sarjakestävyyden parantuminen tai pitkien sarjojen hallinta. Tein säännöllisesti 20
                toiston sarjoja. Niin etukyykyssä kuin takakyykyssäkin. Erityisesti takakyykyssä kevyehköt 20 toiston
                sarjat helpottuivat koko ajan. Jalat eivät yksinkertaisesti menneet hapoille ja noinkin pitkä sarja
                alkoi tuntumaan jo melkein kivalta. Samassa suhteessa kahdeksan toiston sarja alkoi olla jo helppo.</p>

            <h3>Gainssit - Eli mitä jäi käteen?</h3>

            <p>Jos harrastaisin kehonrakennusta, niin olisin mitannut reisieni ympärysmitat tai ottanut vähintään ennen
                ja jälkeen kuvat. Mutta niitä netti on täynnä. Googleta hetki 30 päivän kyykkyhaastetta ja näet, että
                pelkällä ilmakyykyllä jalat muuttuvat kuukaudessa aivan erilaisiksi.
            </p>

            <p>Näin pitkän treenihistorian jälkeen mitään uskomatonta kehityshyppäystä ei enää kohdallani tapahtunut,
                mutta pidän kokeilua silti onnistuneena. En siis saanut 40kg lisää painoa tankoon ja vanhat housut
                mahtuvat edelleen jalkaan. Myös paino pysyi samassa ja peilistä katsoo edelleen takaisin
                kestävyysjuoksija.</p>

            <p>
                Kuormituksesta huolimatta, tein kokeilun aikana parhaat tulokseni niin etukyykyssä kuin
                thrustereissakin. Ja
                kunhan saan purettua tämän kumuloituneen väsymyksen pois jaloistani ja kevennän treenejä hetkeksi, niin
                uskon, että tulokset vain paranevat.</p>

            <p>
                Parasta ja antoisinta tässä haasteessa oli ehkä kuitenkin itse kyykkyliikkeen hallinnan paraneminen ja
                sitä kautta liikkeestä saatava nautinto. Nyt minusta on paljon mukavampi tehdä etukyykkyä ja
                thrustereita.</p>

            <p>Ehkä ensi kerralla kokeilen kuukauden ajan säännöllistä venyttelyä.</p>

            <p>-Markus</p>
        </article>




        <section class="container">
            <h2>Lue seuraavaksi</h2>
            <div class="row">
                <article class="blog col-xs-12 col-md-4">
                    <BlogSummary blogPath='6-syyta-tehda-nopeusvoimaharjoittelua' title='6 syytä tehdä nopeusvoimaharjoittelua' titlePic='nopeusharjoittelu.jpg' blogDate='' firstPara='Lihasten tuottama voima voidaan lajitella käytännössä kolmeen luokkaan. Kaiken kivijalka on kestovoima, jonka päälle rakennetaan maksimi- ja nopeusvoima.'></BlogSummary>
                </article>
                <article class="blog col-xs-12 col-md-4">
                    <BlogSummary blogPath='2022-09-11_otevoima' title='Otteen ja puristusvoiman vahvistaminen' titlePic='2022/FatGripzMave2.jpg' blogDate='' firstPara='Hyvästä puristusvoimasta on hyötyä niin kuntosalilla kuin kotitöissä. Lue tästä vinkit otevoiman kehittämiseen.'></BlogSummary>
                </article>
                <article class="blog col-xs-12 col-md-4">
                    <BlogSummary blogPath='stressitomasti-tuloksiin' title='Stressittömästi tuloksiin' titlePic='riippumatto.jpg' blogDate='' firstPara='Meillä kaikilla on jokin syy motivaattorina, minkä vuoksi treenaamme - jos ja kun treenaamme. Jos haluat näkyviä tuloksia, tai vaikka treenaisit vain omaksi iloksesi tai puolisosi käskystä, kannattaa tämä lukea.'></BlogSummary>
                </article>
            </div>
        </section>



    </div>
{/if}

<style>


</style>